module.exports = __webpack_public_path__ + "img/T916.a68a366f.jpg";